import { ComponentCO2 } from '@acies/domain';
import { SessionStorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
import { Subscription } from 'rxjs';
import CO2Model from '../models/co2-model';
import ListComponentCO2Model from '../models/list-component-co2-model';
import CO2Service from '../services/co2-service';

export default class ListComponentCO2Controller {
	#co2Service: CO2Service;
	#listComponentCO2Model: ListComponentCO2Model;
	#co2Model: CO2Model;
	#userService: UserService;
	#subscriptions = new Subscription();
	#loadSubscription: Subscription | null = null;
	#loadRequestId = 0;
	#resetSelectedComponentCO2: () => void;
	public constructor(co2Model: CO2Model, co2Service: CO2Service, userService: UserService, sessionStorageService: SessionStorageService, resetSelectedComponentCO2: () => void) {
		this.#co2Model = co2Model;
		this.#co2Service = co2Service;
		this.#userService = userService;
		this.#listComponentCO2Model = co2Model.listComponentCO2Model;
		this.#resetSelectedComponentCO2 = resetSelectedComponentCO2;
		this.#subscriptions.add(userService.account$.subscribe(this.#accountChanged.bind(this)));
		this.#subscriptions.add(sessionStorageService.watch('User.SelectedEnvironment').subscribe(this.#selectedEnvironmentChanged.bind(this)));
	}

	public destroy(): void {
		this.#subscriptions.unsubscribe();
		this.#loadSubscription?.unsubscribe();
	}

	#accountChanged(value: unknown): void {
		this.#resetDataSets();
		if (value) {
			this.#loadComponentsCO2();
		} else {
			this.#cancelLoad();
			this.#listComponentCO2Model.globalSpinnerVisible = false;
		}
	}

	#selectedEnvironmentChanged(value: string | null): void {
		if (!value || !this.#userService.account) {
			this.#cancelLoad();
			this.#resetDataSets();
			this.#listComponentCO2Model.globalSpinnerVisible = false;
			return;
		}

		this.#resetDataSets();
		this.#loadComponentsCO2();
	}

	#resetDataSets(): void {
		this.#listComponentCO2Model.globalSpinnerVisible = true;
		this.#listComponentCO2Model.co2Collection.clear();
		this.#co2Model.listComponentCO2LinkModel.co2LinkCollection.clear();
		this.#listComponentCO2Model.firstSelectedItem = null;
		this.#listComponentCO2Model.selectAllCheckBoxEnabled = false;
		this.#resetSelectedComponentCO2();
	}

	#cancelLoad(): void {
		this.#loadRequestId += 1;
		this.#loadSubscription?.unsubscribe();
		this.#loadSubscription = null;
	}

	#loadComponentsCO2(): void {
		this.#cancelLoad();
		const requestId = this.#loadRequestId;
		this.#loadSubscription = this.#co2Service.listComponentCO2().subscribe((response) => {
			if (requestId === this.#loadRequestId) {
				this.#listComponentCO2Model.globalSpinnerVisible = false;
				if (Array.isArray(response)) {
					this.#updateModelFromResponse(response);
				} else {
					this.#co2Model.showGlobalErrorDialog(response);
				}
				this.#updateSelectAllCheckBoxEnabled();
			}
		});
	}

	#updateModelFromResponse(response: ComponentCO2[]): void {
		this.#listComponentCO2Model.co2Collection.clear();
		this.#listComponentCO2Model.co2Collection.addItems(response);
		// the .collection is the collection data after filtering and sorting, so we use
		// that instead of picking the response.at(0), since it could change
		const firstItem = this.#listComponentCO2Model.co2Collection.collection.at(0);
		if (firstItem) {
			this.#listComponentCO2Model.firstSelectedItem = firstItem;
		}
	}

	#updateSelectAllCheckBoxEnabled(): void {
		this.#listComponentCO2Model.selectAllCheckBoxEnabled = this.#listComponentCO2Model.co2Collection.length > 0;
	}
}
